import { ref } from 'vue';
import type { PaginationMetadata, PaginationLinks } from '@/types/browser';

export function usePaginatedData() {
    const metadata = ref<PaginationMetadata>({ total: null, start: null, end: null });
    const links = ref<PaginationLinks>({ next: null, current: null, previous: null });

    const updatePagination = (data: any) => {
        if (data?.metadata) metadata.value = data.metadata;
        if (data?.links) links.value = data.links;
    };

    return { metadata, links, updatePagination };
}
